import React from 'react'
import Breadcrumb from '../components/Breadcrumb'
import './ToolLayout.css'

const ToolLayout = ({
  children,
  title,
  description,
  breadcrumbItems,
  className = '',
  ...props
}) => {
  const classes = ['tool-layout', className].filter(Boolean).join(' ')

  return (
    <main className={classes} {...props}>
      <div className="tool-layout-container">
        <div className="tool-layout-nav">
          <Breadcrumb customItems={breadcrumbItems} />
        </div>

        {(title || description) && (
          <div className="tool-layout-header">
            {title && <h1 className="tool-layout-title">{title}</h1>}
            {description && <p className="tool-layout-intro">{description}</p>}
          </div>
        )}

        <div className="tool-layout-content">{children}</div>
      </div>
    </main>
  )
}

export default ToolLayout